export const storage_keys = {
  api_last_team_id: 'api:last_team_id',
  degraded_banner_dismissed_at: 'dashboard:degraded_banner_dismissed_at',
  show_get_started: 'dashboard:show_get_started',
  show_outpost_get_started: 'dashboard:show_outpost_get_started',
  // v2: the cached shape changed from { source_url, console_url } to
  // { ingest_url, inspect_url } — bump the key so a stale v1 object isn't reused
  // (its missing fields would blank the destination prefill and the View link).
  outpost_get_started_test_url: 'dashboard:outpost_get_started_test_url_v2',
  hide_member_trial_modal: 'dashboard:hide_member_trial_modal',
  metric_date_range_relative: 'dashboard:metric_date_range_relative',
  first_day_of_week: 'dashboard:first_day_of_week',
  timezone: 'dashboard:timezone',
  session: {
    dashboard_session: 'dashboard:session',
  },
};
